/**
 * Provides access to a locally cached media asset such as a video or an image. The objectURL
 * property specifies the local objectURL to the in-cache asset. To display the asset, assign
 * objectURL to the src attribute of <img> or <video> elements display anywhere a public URL
 * could be used.
 */
export class MediaAsset {
  constructor (objectURL, type) {
    this.objectURL = objectURL;
    this.type = type;
  }
}